/**
 * In-content videos for the orthodontic pages.
 * `desktop` = 16:9 file (screens ≥ 768px), `mobile` = 9:16 file (narrower screens).
 * Only the file matching the visitor's screen size is loaded.
 */
export type ResponsiveVideo = {
  desktop: string
  mobile: string
}

export const orthodonticVideos: Record<
  | 'orthodontics'
  | 'clearAligners'
  | 'invisalignSpark'
  | 'appliances'
  | 'childrens',
  ResponsiveVideo
> = {
  orthodontics: {
    desktop:
      'https://cdn.magicpatterns.com/uploads/wsNhphV3JacApoxFd2AQHP/dentico_orthodontics_overview_16x9%20(1).mp4',
    mobile:
      'https://cdn.magicpatterns.com/uploads/ovFXZAuMHyzSSuRm9xK3uU/dentico_orthodontics_overview_mobile_9x16.mp4',
  },
  clearAligners: {
    desktop:
      'https://cdn.magicpatterns.com/uploads/dYovqFDZiLcMgJr7ac6pbQ/dentico_clear_aligners_16x9.mp4',
    mobile:
      'https://cdn.magicpatterns.com/uploads/cs9ApaxNj4rmFfURGwZUmW/dentico_clear_aligners_mobile_9x16.mp4',
  },
  invisalignSpark: {
    desktop:
      'https://cdn.magicpatterns.com/uploads/cU4hH94hNY5aFV9N1c8XPK/dentico_invisalign_spark_16x9.mp4',
    mobile:
      'https://cdn.magicpatterns.com/uploads/axqwwDpoFLuKV3MRwkNZ9E/dentico_invisalign_spark_mobile_9x16.mp4',
  },
  appliances: {
    desktop:
      'https://cdn.magicpatterns.com/uploads/mF2GSwThPSphcwNbSjtUs6/dentico_orthodontic_appliances_16x9.mp4',
    mobile:
      'https://cdn.magicpatterns.com/uploads/bQ2B3hzAcQ4KpEhxq4bBs2/dentico_orthodontic_appliances_mobile_9x16.mp4',
  },
  childrens: {
    desktop:
      'https://cdn.magicpatterns.com/uploads/9TSeGdWnCpT7WoP1NJeNkj/dentico_childrens_orthodontics_16x9.mp4',
    mobile:
      'https://cdn.magicpatterns.com/uploads/foUKxbPx2mvWPRLp6oGEwZ/dentico_childrens_orthodontics_mobile_9x16.mp4',
  },
}
